import { FlexBox, Icon, Text } from '@dixa/lib-shared-habla';
import { typography } from '@dixa/lib-shared-tokens';
import { QueueMetricType } from 'lib-dashboard-types';
import { ampli } from 'lib-shared-tracking';
import { ComponentProps, useCallback } from 'react';

import styles from './queueDashboardMetricTitle.module.scss';

export type QueueDashboardMetricTitleProps = {
  /** The queue metric type. */
  metricType: QueueMetricType;
  /** If provided, it will override the default title based on the metric type. */
  title?: string;
} & ComponentProps<typeof Text.Paragraph>;

export const QueueDashboardMetricTitle = ({
  children,
  metricType,
  title = defaultTitles[metricType],
  ...textProps
}: QueueDashboardMetricTitleProps): JSX.Element => {
  const handleHelperClick = useCallback(() => {
    ampli.dashboardMetricHelperClicked({
      dashboard: 'queues',
      metric: metricType,
    });
  }, [metricType]);

  return (
    <div className={styles.root}>
      <Text.Paragraph as="span" variant="4" subdued {...textProps}>
        {title}
      </Text.Paragraph>

      <FlexBox
        as="span"
        role="button"
        data-dashboard-metric-helper={metricType}
        data-elevio-allow-propagation
        onClick={handleHelperClick}
      >
        <Icon
          name="info"
          color={typography.color.tertiary}
          style={{ cursor: 'pointer' }}
        />
      </FlexBox>
    </div>
  );
};

const defaultTitles: Record<QueueMetricType, string> = {
  agent_presence: 'Agents presence',
  pending_conversations: 'Pending conversations',
  queued_time: 'Longest queued time',
  daily_conversations: 'Answered / Received',
  response_time: 'Avg. response time',
};
